import { useCallback } from 'react';
import { useAuth } from './AuthContext';
import { hasPermission } from './permissions';

/** `const can = usePermission(); can('students:create')` — the same check the route guards and the API use. */
export const usePermission = () => {
  const { user } = useAuth();
  return useCallback((permission?: string | string[]) => hasPermission(user, permission), [user]);
};
